/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

// This code is auto-generated by Plasmic; please do not edit!
// Plasmic Project: frhoorZk3bxNXU73uUyvHm

import { createUseGlobalVariants } from "@plasmicapp/react-web";

import { useScreenVariants as useScreenVariantsdj0PzuYeI5XyS } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: DJ0PzuYE_I5xyS/globalVariant

export const _useGlobalVariants = createUseGlobalVariants({
  screen: useScreenVariantsdj0PzuYeI5XyS,
});
